import { render } from "./edit-road.svg?vue&type=template&id=66892f54?inline"
const script = {}
script.render = render

export default script